module.exports = __webpack_public_path__ + "static/Glober_Regular-8aebbdc337b582b61d23791be8e13991.woff2";